import * as api from 'commons/js/api'

import {
    formatDateTime,
    parseMoment,
} from 'commons/js/util/dateConverter'
import {
    takeLatest,
} from 'commons/js/util/promiseUtils'

import {
    TIMESTAMP_FORMAT,
} from 'commons/js/constants'
import Routes from 'commons/js/routes/routes'

export const searchParkings = takeLatest((params) => {
    return api.searchParkings(params)
})

export function getParkingUrl ({ parkingId, parkingSlug, provinceSlug, startDate, endDate }) {
    return Routes.parkingPath({
        slug: parkingSlug,
        province: provinceSlug,
        idParking: parkingId,
        start_date: formatDateTime(parseMoment(startDate, TIMESTAMP_FORMAT)),
        end_date: formatDateTime(parseMoment(endDate, TIMESTAMP_FORMAT)),
    })
}
